import { render, staticRenderFns } from "./RealNameAuth.vue?vue&type=template&id=d2f5eeec&scoped=true"
import script from "./RealNameAuth.vue?vue&type=script&lang=js"
export * from "./RealNameAuth.vue?vue&type=script&lang=js"
import style0 from "./RealNameAuth.vue?vue&type=style&index=0&id=d2f5eeec&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2f5eeec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/ap/jenkins/workspace/prod-ykd360-admin-front(医可达旧管理端)/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2f5eeec')) {
      api.createRecord('d2f5eeec', component.options)
    } else {
      api.reload('d2f5eeec', component.options)
    }
    module.hot.accept("./RealNameAuth.vue?vue&type=template&id=d2f5eeec&scoped=true", function () {
      api.rerender('d2f5eeec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/agent/sub/RealNameAuth.vue"
export default component.exports